// src/components/TopicMafia/topicMafiaUi.js

export const CONTROL_H = 56;
export const CONTROL_W = 140;

// ✅ 헤더(우측 버튼) 전용: 1줄 툴바 고정
export const HEADER_H = 40;
export const HEADER_MINI_W = 120;
export const HEADER_MAIN_MIN_W = 120;

export const STATUS_LABEL = {
    WAITING: "대기",
    REVEAL: "주제 확인",
    PLAYING: "진행",
    VOTING: "투표",
    GUESS: "마피아 추측",   // ✅ 추가
    ENDED: "종료",
};

export const STATUS_COLOR = {
    WAITING: "default",
    REVEAL: "info",
    PLAYING: "success",
    VOTING: "warning",
    GUESS: "secondary",     // ✅ 추가 (취향대로)
    ENDED: "default",
};

// ✅ 프론트에서 잡아둘 기본 호스트 설정(대기 단계)
export const DEFAULT_HOST_SETTINGS = {
    topic_category_id: "",
    max_players: 8,
    total_rounds: 3,
    minority_count: 1,
    turn_time_limit_sec: 25,
    vote_time_limit_sec: 30,
};

// ✅ WS/REST say 중복 제거
export function dedupeSay(items) {
    const seen = new Set();
    const out = [];
    for (const s of items) {
        // ✅ id가 있으면 id 우선. 없으면 created_at까지 포함해 중복 제거가 과해지는 걸 방지 
        const key =
            s.id ??
            `${s.round}-${s.turn_index}-${s.player_id}-${s.created_at ?? ""}`;
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(s);
    }
    return out;
}

// ─────────────────────────────────────────────
// WS URL helper
// ─────────────────────────────────────────────
export function makeWsUrl(roomId) {
    // ✅ API baseURL을 우선 기준으로 WS host를 잡는다. 
    // - 운영: 프론트=백 같은 도메인이면 기존 window.location으로도 OK 
    // - 개발: localhost:3000 + API:8000 같은 경우도 대응 가능 
    const base =
        process.env.REACT_APP_API_BASE_URL ||
        `${window.location.protocol}//${window.location.host}`;

    const u = new URL(base);
    const wsProto = u.protocol === "https:" ? "wss:" : "ws:";
    return `${wsProto}//${u.host}/ws/topic-mafia/${roomId}/`;
}

// ─────────────────────────────────────────────
// 2번 스타일: 공통 UI Sx
// ─────────────────────────────────────────────
export const cardSx = {
    p: 3,
    borderRadius: 4,
    border: "1px solid",
    borderColor: "divider",
    bgcolor: "background.paper",
};

export const sectionTitleSx = { fontWeight: 900 };

export const mainActionBtnSx = {
    borderRadius: 3,
    fontWeight: 900,
    px: 2,
    boxShadow: 2,
};

export const subActionBtnSx = {
    borderRadius: 3,
    fontWeight: 800,
    px: 2,
};

export const controlBtnSx = {
    height: CONTROL_H,
    minHeight: CONTROL_H,
    borderRadius: 3,
    fontWeight: 900,
    px: 2,
    whiteSpace: "nowrap",
};

// ✅ 헤더 버튼은 control과 분리 (높이/폭/패딩을 슬림하게)
export const headerMiniBtnSx = {
    height: HEADER_H,
    minHeight: HEADER_H,
    width: HEADER_MINI_W,
    minWidth: HEADER_MINI_W,
    px: 0,
    borderRadius: 999,
    fontWeight: 800,
    whiteSpace: "nowrap",
};

export const headerMainBtnSx = {
    height: HEADER_H,
    minHeight: HEADER_H,
    minWidth: HEADER_MAIN_MIN_W,
    px: 2,
    borderRadius: 999,
    fontWeight: 900,
    whiteSpace: "nowrap",
};

export const controlFieldSx = {
    "& .MuiInputBase-root": { height: CONTROL_H },
    "& .MuiInputBase-input": {
        height: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
    },
};
